import OLD_API from './api-old';
import NEW_API from './api-new';

export default process.env.GATSBY_ENV === 'sandbox' ? NEW_API : OLD_API